// Mock data for Penotti Atelier products
export const mockProducts = [
  {
    id: 'classic-duo',
    name: 'Duo Signatur',
    description: 'Signature hazelnut-chocolate and vanilla swirl. The iconic combination that started it all.',
    category: 'Signature',
    image: 'https://customer-assets.emergentagent.com/job_dutch-spread-shop/artifacts/6xzrdy6c_image.png',
    isNew: false,
    ingredients: ['Premium hazelnuts from Turkey', 'Italian cocoa', 'Madagascar vanilla', 'Dutch cream'],
    details: 'Handcrafted in small batches. Each jar represents our commitment to excellence and the finest ingredients sourced from around the world.',
  },
  {
    id: 'pure-hazelnut',
    name: 'Uno Signatur',
    description: 'Single-origin Piemonte hazelnuts blended to perfection with premium dark chocolate.',
    category: 'Atelier Reserve',
    image: 'https://customer-assets.emergentagent.com/job_dutch-spread-shop/artifacts/mrat0rsj_image.png',
    isNew: true,
    ingredients: ['100% Piemonte hazelnuts', 'Single-origin dark chocolate', 'Raw cane sugar'],
    details: 'Our most refined creation. Pure, intense, unforgettable.',
  },
  {
    id: 'white-chocolate',
    name: 'Uno Signatur Blanc',
    description: 'Silky white chocolate infused with subtle notes of vanilla and caramel.',
    category: 'Signature',
    image: 'https://customer-assets.emergentagent.com/job_dutch-spread-shop/artifacts/b0gfsur6_image.png',
    isNew: false,
    ingredients: ['Belgian white chocolate', 'Tahitian vanilla', 'Dutch cream', 'Sea salt'],
    details: 'A delicate balance of sweetness and sophistication.',
  },
  {
    id: 'praline',
    name: 'Uno Signatur Praliné',
    description: 'Rich praline blend with roasted hazelnuts and caramelized almonds.',
    category: 'Signature',
    image: 'https://customer-assets.emergentagent.com/job_dutch-spread-shop/artifacts/e3e2z94q_image.png',
    isNew: true,
    ingredients: ['Caramelized Piemonte hazelnuts', 'Valencia Marcona almonds', 'French cane sugar', 'Fleur de Sel'],
    details: 'Authentic praliné craftsmanship. Caramelized perfection.',
  },
];

export const collections = [
  {
    id: 'signature',
    name: 'Signature Collection',
    description: 'Our timeless classics. The spreads that define Penotti Atelier.',
    productIds: ['classic-duo', 'white-chocolate', 'salted-caramel'],
  },
  {
    id: 'atelier-reserve',
    name: 'Atelier Reserve',
    description: 'Limited editions crafted for the discerning palate. Small batch, extraordinary quality.',
    productIds: ['pure-hazelnut', 'praline', 'dark-intense'],
  },
];

export const brandStory = {
  title: 'The Atelier',
  subtitle: 'Where Dutch Heritage Meets Modern Luxury',
  content: `Since 1970, the Penotti name has been synonymous with exceptional chocolate spreads in the Netherlands. 
  
  Penotti Atelier represents the evolution of this legacy—a commitment to artisanal craftsmanship, premium ingredients, and uncompromising quality. Each jar is a testament to our belief that the finest spreads deserve to be savored, celebrated, and shared.
  
  From the hazelnut groves of Turkey to the cacao plantations of South America, we source only the world's finest ingredients. Our master artisans blend tradition with innovation, creating spreads that transcend the ordinary.`,
  values: [
    'Premium ingredients sourced globally',
    'Small-batch artisanal production',
    'Dutch craftsmanship heritage',
    'Sustainable and ethical sourcing',
  ],
};